const LEAD_SOURCE_VALUES = [
  "fo-home-page",
  "john-hancock",
  "PPC",
  "PPC Local",
  "RPN",
  "sitebuilder-page",
] as const;

type LeadSourceValue = (typeof LEAD_SOURCE_VALUES)[number];

const DEFAULT_SITE_BUILDER_LEAD_SOURCE: LeadSourceValue = "sitebuilder-page";
const DEFAULT_FRANCHISE_HOME_LEAD_SOURCE: LeadSourceValue = "fo-home-page";

export {
  DEFAULT_FRANCHISE_HOME_LEAD_SOURCE,
  DEFAULT_SITE_BUILDER_LEAD_SOURCE,
  LEAD_SOURCE_VALUES,
};
